import { Route } from '@angular/router';
import { CMS_CONTENT_PATH } from '../mgs-path-defs';
import { cmsContentResolver } from './cms-content.resolver';

export const cmsContentRoute: Route = {
  path: CMS_CONTENT_PATH + '/:context/:id',
  title: 'CMS Content',
  loadComponent: () => import('./cms-content.component'),
  resolve: { cmsContent: cmsContentResolver }
};
